import { useState } from "react";
import {
  Box,
  Typography,
  Tooltip,
  IconButton,
  Collapse,
  Divider,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const truncate = (value, length = 12) =>
  value.length > length ? value.slice(0, length) + "…" : value;
const CopyableField = ({ label, value, copy = true }) => {
  if (!value) return null;

  return (
    <Box display="flex" alignItems="center" mb={1}>
      <Typography sx={{ fontWeight: 600, width: 170 }}>{label}:</Typography>

      <Tooltip title={value}>
        <Typography sx={{ fontFamily: "monospace" }}>
          {truncate(value)}
        </Typography>
      </Tooltip>

      {/* Copy button – only if copy=true */}
      {copy && (
        <Tooltip title="Copy">
          <IconButton
            size="small"
            sx={{ ml: 1 }}
            onClick={() => navigator.clipboard.writeText(value)}
          >
            <ContentCopyIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};


export const PaymentDetailsPreview = ({ details, paymentStatus, merchantTransactionID }) => {
  const [open, setOpen] = useState(false);
  const d = details[0];
  const capitalizeFirst = (str) =>
    typeof str === "string" && str.length > 0
      ? str.charAt(0).toUpperCase() + str.slice(1)
      : str;


  return (
    <Box>
      {/* Compact Summary */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          background: "#1E1E1F",
          p: 1.5,
          borderRadius: "10px",
          cursor: "pointer",
          border: "1px solid rgba(255,255,255,0.08)",
          "&:hover": {
            background: "#262627",
            transition: "0.2s",
          },
        }}
        onClick={() => setOpen(!open)}
      >
        <Box>
          <Typography
            fontWeight={600}
            sx={{ mb: 0.5, color: "#FFFFFF" }}
          >
            {capitalizeFirst(paymentStatus)
              || "--"}
          </Typography>

        </Box>

        <ExpandMoreIcon
          sx={{
            color: "#fff",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "0.2s",
          }}
        />
      </Box>

      {/* Expandable Full Details */}
      <Collapse in={open}>
        <Box
          mt={2}
          p={2}
          sx={{
            borderRadius: 2,
            background: "#161617",
            border: "1px solid rgba(255,255,255,0.08)",
          }}
        >
          <CopyableField label="Processor" value={d.paymentProcessor} />
          <CopyableField label="Processor Response" value={d.processorResponseMessage} />
          <CopyableField label="Processor Code" value={d.processorResponseCode} />
          <CopyableField label="Processor Tx ID" value={d.processorTransactionID} />
          <CopyableField label="Merchant Tx ID" value={merchantTransactionID} copy={true}
          />
          <Divider sx={{ my: 1, borderColor: "rgba(255,255,255,0.1)" }} />

          <CopyableField
            label="Payment Method"
            value={`${d.network} ${d.paymentMethodLastFour}`} copy={false}

          />
          <CopyableField label="Payment Method Token" value={d.paymentMethodToken} copy={false}
          />



        </Box>
      </Collapse>
    </Box>
  );
};
